module.exports = __webpack_public_path__ + "media/assets/images/reattivo-01329529b2bd1c61eca267c021245215.png";